<template>
  <v-card
    :style="`height: calc(100vh - 74px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
    class="col-12 pb-0"
  >
    <v-row
      class="mx-0 px-2"
    >
      <select-project
        v-model="project"
        class="package-project_selector"
        style="max-width: 200px"
      >
      </select-project>

      <v-select
        class="col-2 pb-0"
        label="Type"
        :items="type_list"
        v-model="types"
        multiple
        style="max-width: 200px"
      >
        <template v-slot:selection="{ item: chipItem, index }">
          <div style="max-width: 180px" class="v-select__selection v-select__selection--comma" v-if="index < chipCount">{{ chipItem.text || chipItem }}{{ index < chipCount - 1 ? ',' : '' }} &nbsp;</div>
          <span
            class="caption float-right"
            v-if="index === chipCount && (types || []).length > chipCount"
          >(+{{ (types || []).length - chipCount }} others)</span>
        </template>
      </v-select>

      <v-autocomplete
        :loading="benefitListLoading"
        class="col-3 pb-0"
        label="Benefit"
        multiple
        auto-select-first
        style="max-width: 320px"
        :items="benefit_list"
        v-model="benefit_ids"
      >
        <template v-slot:selection="{ item: chipItem, index }">
          <div style="max-width: 180px" class="v-select__selection v-select__selection--comma" v-if="index < chipCount">{{ chipItem.text || chipItem }}{{ index < chipCount - 1 ? ',' : '' }} &nbsp;</div>
          <span
            class="caption float-right"
            v-if="index === chipCount && (benefit_ids || []).length > chipCount"
          >(+{{ (benefit_ids || []).length - chipCount }} others)</span>
        </template>
        <template v-slot:item="{attrs, on, item}">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-action>
              <v-simple-checkbox
                :value="attrs.inputValue"
              />
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                <span v-html="item.text"></span>
                <small class="float-right">({{ item.value }})</small>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
      <date-picker
        v-model="from"
        label="Date From"
        style="max-width: 140px;"
      />

      <date-picker
        v-model="to"
        label="Date To"
        style="max-width: 140px"
      />

      <v-btn
        color="info"
        class="mt-3 ml-3"
        :loading="loading"
        :disabled="loading"
        @click="search"
      >
        Search
      </v-btn>

      <export :fields="exportFields" :data="filteredItems" report-name="Bonuses in Packages" v-if="filteredItems.length > 0" without_sg />
    </v-row>

    <v-data-table
      :class="`bonus-tools-dt bonuses-package-dt ${$store.state.auth.checkAccess({key: 'kiosk.access', value: true}) ? 'padding-footer' : ''}`"
      :loading="loading"
      :server-items-length="total"
      :headers="headers"
      fixed-header
      group-by="groupby"
      :options.sync="options"
      :items="filteredItems"
      :footer-props="{'items-per-page-options':[ 50, 100, 200 ]}"
      :items-per-page="50"
      :height="`calc(100vh - 215px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
      style="z-index: 0; position: relative;"
    >
      <template v-slot:body.prepend>
        <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
          <td
            v-for="header in headers"
            :key="header.value"
            style="height: auto"
          >
            <v-select
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
              hide-details
              dense
              small
              multiple
              clearable
              persistent-hint
              single-line
              class="ma-0 pa-0"
              :items="filters[header.value].values || columnValueList(header.value)"
              :style="{width: (filters[header.value] || {width: false}).width}"
              v-model="filters[header.value].data"
            ></v-select>
            <v-text-field
              class="ma-0 pa-0"
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
              v-model="filters[header.value].data"
              :style="{width: (filters[header.value] || {width: false}).width}"
              hide-details
            ></v-text-field>
          </td>
        </tr>
      </template>

      <template v-slot:group.header="{ items, headers }">
        <td>
          {{ items[0].package_id }}
        </td>
        <td>
          <a :href="'/user-management/' + items[0].login " target="_blank">{{ items[0].login }}</a>
        </td>
        <td :colspan="headers.length - 2"></td>
      </template>

      <template v-slot:item.row_num="{ item }">
        <span class="row_num"></span>
      </template>

      <template v-slot:item.package_id="{ item, header }">
      </template>
      <template v-slot:item.login="{ item, header }">
        <!--        <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>-->
      </template>
      <template v-slot:item.created="{ item }">
        <span class="text-no-wrap">{{ item.created }}</span>
      </template>
      <template v-slot:item.updated="{ item }">
        <span class="text-no-wrap">{{ item.updated }}</span>
      </template>
      <template v-slot:item.account_id="{ item, header }">
        <!--        <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>-->
      </template>

    </v-data-table>
  </v-card>
</template>

<style scoped>
  .package-project_selector {
    max-width: 300px;
  }

  ::v-deep.bonuses-package-dt .v-row-group__header td,
  .bonuses-package-dt .v-row-group__header td {
    height: 30px;
  }

  ::v-deep.bonuses-package-dt .v-row-group__header,
  .bonuses-package-dt .v-row-group__header {
    background-color: #e4e4e452;
  }
</style>


<script>
  import { filter, get, map } from 'lodash'
  import { API } from '@/utils/api'
  import moment from 'moment'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },

    data: () => ({
      chipCount: 1,
      benefitListLoading: false,
      loading: false,

      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),

      project: null,
      items: [],
      total: 0,
      benefit_list: [],
      benefit_ids: [],

      type_list: [
        { text: 'Period', value: 'period' },
        { text: 'Autobonus', value: 'autobonus' },
        { text: 'Promotional', value: 'promo' },
        { text: 'Cashback', value: 'cashback' },
        { text: 'Retention', value: 'retention' },
        { text: 'Achievement', value: 'achievement' },
        { text: 'Journey', value: 'journey' },
        { text: 'Lucky Box', value: 'luckybox' },
      ],
      types: [],

      filters: {
        package_id: { data: [], type: 'text', width: '120px' },
        login: { data: [], type: 'text' },
        currency: { data: [], type: 'select', width: '100px' },
        // 'rules.recurring': { data: [], type: 'select' },
        manual_check: { data: [], type: 'select', width: '100px' },
        status: { data: [], type: 'select', width: '150px' },

        // ref_id: { data: [], type: 'text' },
        // name: { data: [], type: 'text' },
        // enabled: { data: [], type: 'select', values: [ { text: 'Yes', value: 1 }, { text: 'No', value: 0 } ] },
      },
      headers: [
        { text: 'PackageID', value: 'package_id' },
        { text: 'Login', value: 'login' },
        { text: 'Currency', value: 'currency' },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Choice', value: 'choice' },
        { text: 'Bonus', value: 'bonus_type' },
        { text: 'Amount', value: 'amount' },
        { text: 'Wager', value: 'wager' },
        { text: 'Game', value: 'game' },
        { text: 'Status', value: 'status' },
        { text: 'Created', value: 'created' },
        { text: 'Updated', value: 'updated' },
        // { text: '', value: 'action' },
      ],
      options: {},
    }),

    computed: {
      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval(d[f].toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes((d[f] || ''))
                || (this.filters[f].data.includes(true) && ((d[f] || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((d[f] || '').toString().toLowerCase()).length == 0)
                || (typeof d[f] != 'boolean' && ((d[f] || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    watch: {
      project: {
        handler () {
          this.loadBenefitList()
        },
      },
      types: {
        handler () {
          this.loadBenefitList()
        },
      },
      options: {
        handler () {
          this.search()
        },
        deep: true
      },
    },

    methods: {

      columnValueList (val) {
        return filter(this.items.map(d => d[val]), (i) => i)
      },

      loadBenefitList: function () {
        if (this.benefitListLoading == true) {
          return
        }
        this.benefitListLoading = true

        this.benefit_ids = []
        try {
          API.call('/bonus_tools/dictionary/benefit_list.json', {
            types: this.types,
          }, null, this.project).then(resp => {

            this.benefit_list = get(resp, 'data', [])

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.benefitListLoading = false
          })
        } catch (e) {
          this.benefitListLoading = false
          console.log(e)
        }
      },

      search: function () {
        if (this.loading == true) {
          return
        }
        this.loading = true
        try {
          API.call('/bonus_tools/package_bonus_list.json', {
            ...this.options,
            benefit_ids: this.benefit_ids,
            from: this.from,
            to: this.to,
            types: this.types
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])
            if (get(resp, 'total', false)) {
              this.total = resp.total
            }
            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },
    }
  }
</script>
